import PT from './pt';
import EN from './en';

const languages = {
  ...PT,
  ...EN
};

export { languages };
